import { createAction, props } from '@ngrx/store';

import { SortDirection } from '../constants';

export const setWorkspaceFilterString = createAction(
  '[Workspace] Set Workspace Filter String',
  props<{ filterString: string }>(),
);

export const setWorkspaceSortingField = createAction(
  '[Workspace] Set Workspace Sorting Field',
  props<{ sortingField: string }>(),
);

export const setWorkspaceSortingDirection = createAction(
  '[Workspace] Set Workspace Sorting Direction',
  props<{ sortingDirection: SortDirection }>(),
);

export const setWorkspaceTab = createAction(
  '[Workspace] Set Workspace Tab',
  props<{ tab: 'active' | 'archived' | 'deleted' }>(),
);

export const setWorkspaceObjectsLifeCycle = createAction(
  '[Workspace] Set Workspace Objects Lifecycle',
  props<{ workspaceId: string; workspaceObjectsLifeCycle: number }>(),
);
